export { LOCALE_META } from "./locale-meta";
export type { LocaleMeta } from "./locale-meta";
